import { module } from 'angular';

import { ResponseMessageView } from './';
import { default as responderServiceName, ResponderService } from './responder.service';

export default module('contact.responder', [ResponseMessageView]).service(responderServiceName, ResponderService).name;
